<template>
  <section class="block">
    <div class="wrapper">
      <div class="block-header" data-aos="fade-down" data-aos-anchor-placement="top-center">
        <slot name="header"></slot>
        <span v-if='preText' class="pre_text" :class='preTextClass'>{{ $t(preText) }}</span>
        <h2 class="title" v-if='title' :class='titleClass'>{{ $t(title) }}</h2>
        <p v-if='text' class='text' :class='textClass'>{{ $t(text) }}</p>
      </div>
      <slot></slot>
    </div>
  </section>
</template>

<script>

export default {
  name: "Block",
  props: {
    title: String,
    text: String,
    preText: String,
    titleClass: String,
    preTextClass: String,
    textClass: String,
  },
  data: () => ({

  }),
};
</script>

<style lang="scss" scoped>
@use "../../scss/variables" as *;

.block {
  position: relative;
  width: 100%;

  &:not(:last-child) {
    margin-bottom: 140px;
  }
}

.wrapper {
  position: relative;
  margin: 0 auto;
  width: 100%;
  z-index: 2;
}

.block-header {
  display: flex;
  flex-direction: column;
  padding-bottom: 24px;
}

.pre_text {
  margin: 0 auto 20px;
  color: var(--brand-color);
  font-size: 24px;
  font-weight: 800;
  text-align: center;
}

.circle {
  border-radius: 26px;
  padding: 15px 30px 13px;
  border: 1px solid #909DA2;
  line-height: 1.2;
  letter-spacing: -0.03em;
  transition: 0.3s all;
  font-size: 18px;
  margin: 0 auto 22px;
}

.title {
  padding: 0 0 41px;
  line-height: 1.2;
  font-weight: 600;
  text-align: center;
  letter-spacing: -0.02em;
  color: var(--back-color);
  font-size: 55px;
  margin: 0;
}

.text {
  font-size: 18px;
  font-weight: 400;
  line-height: 21.6px;
  letter-spacing: -0.03em;
  text-align: center;
}

.header-h1 {
  font-size: 64px;
}

@media (max-width: $fullhd) {
  .block:not(:last-child) {
    margin-bottom: 100px;
  }

  .title {
    font-size: 40px;
  }

  .header-h1 {
    font-size: 64px;
  }
}

@media screen and (max-width: $mobile) {
  .title {
    font-size: 28px;
    padding-bottom: 20px;
  }

  .header-h1 {
    font-size: 32px;
  }

  .block-header {
    padding: 0;
  }

  .circle {  padding: 8px 18px;
  }
}
</style>